<template>
  <div class="position-relative">
    <!--1 Presentation-->
    <div class="grid-x bg-slider home-main-slider position-relative">
      <slider-carousel
        :nav="false"
        :items="1"
        :margin="0"
        :arrows="false"
        :autoplay="true"
        :autoplayTimeout="5000"
        :autoplayHoverPause="true"
        :loop="false"
        :dots="true"
        style="width: 100%;"
      >
        <template
          slot="prev"
          style="z-index:1;"
        ></template>
        <template
          slot="next"
          style="z-index:1;"
        ></template>

        <router-link
          class="item position-relative"
          :to="{ name: 'catalog', params: { catalog: 38 }}"
        >
          <img :src="getUrl('home-slider3.jpg')" />
        </router-link>

        <router-link
          class="item position-relative"
          :to="{ name: 'catalog', params: { catalog: 47 }}"
        >
          <img :src="getUrl('home-project-furniture.jpg')" />
        </router-link>

        <router-link
          class="item position-relative"
          :to="{ name: 'catalog', params: { catalog: 9 }}"
        >
          <img :src="getUrl('home-slider1.jpg')" />
        </router-link>

        <router-link
          class="item position-relative"
          :to="{ name: 'catalog', params: { catalog: 1 }}"
        >
          <img :src="getUrl('home-slider2.jpg')" />
        </router-link>
      </slider-carousel>
    </div>

    <img :src="getUrl('home-select-enquiry.jpg')" />

    <!-- HOME FITNESS SECTION -->
    <!--A Presentation-->
    <router-link
      class="grid-x bg-slider home-main-slider position-relative"
      v-for="(item, index) in catalogList.filter(e=>e.id===1)"
      :key="index"
      :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
    >
      <img :src="getUrl(item.imageBigSrc)" />
    </router-link>

    <!--HOME FITNESS Highlights-->
    <div
      class="grid-container full  container"
      style="background: #f7f7f7;"
    >
      <div class="grid-x grid-padding-x grid-padding-y grid-container product-container">
        <div class="cell">
          <h2>
            {{salesHighlight}}
            <hr style="width: 56px;
                    display: inline-block;
      width: 48px;
      margin: 10px 0px 10px 20px;
      border-color: #5f5e5e;
      border-width: 1px;
                " />
          </h2>
        </div>

        <div
          class="cell large-3 medium-4 small-6"
          v-for="(item, index) in listHomeFitness"
          :key="index+10"
          @mouseover="mouseOverIdx = index"
          @mouseleave="mouseOverIdx = -1"
        >
          <router-link
            :to="{
              name: 'product-detail',
              params: {
                productId: item.id,
                catalog: 1,
                entity: item,
              },
            }"
            class="card card-product radius"
            :class="{ shadow: mouseOverIdx === index }"
          >
            <product-card :item="item" />
          </router-link>
        </div>
      </div>
    </div>

    <!-- PROJECT FURNITURE SECTION -->
    <!--A Presentation-->
    <router-link
      class="grid-x bg-slider home-main-slider position-relative"
      v-for="(item, index) in catalogList.filter(e=>e.id===47)"
      :key="index"
      :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
    >
      <img :src="getUrl(item.imageBigSrc)" />
    </router-link>

    <!--PROJECT FURNITURE Highlights-->
    <div
      class="grid-container full  container"
      style="background: #f7f7f7;"
    >
      <div class="grid-x grid-padding-x grid-padding-y grid-container product-container">
        <div class="cell">
          <h2>
            {{salesHighlight}}
            <hr style="width: 56px;
                    display: inline-block;
      width: 48px;
      margin: 10px 0px 10px 20px;
      border-color: #5f5e5e;
      border-width: 1px;
                " />
          </h2>
        </div>

        <div
          class="cell large-3 medium-4 small-6"
          v-for="(item, index) in listHomeFurniture"
          :key="index+10"
          @mouseover="mouseOverIdx = index"
          @mouseleave="mouseOverIdx = -1"
        >
          <router-link
            :to="{
              name: 'product-detail',
              params: {
                productId: item.id,
                catalog: 1,
                entity: item,
              },
            }"
            class="card card-product radius"
            :class="{ shadow: mouseOverIdx === index }"
          >
            <product-card :item="item" />
          </router-link>
        </div>
      </div>
    </div>

    <!-- COVID SECTION -->
    <!--A Presentation-->
    <router-link
      class="grid-x bg-slider home-main-slider position-relative"
      v-for="(item, index) in catalogList.filter(e=>e.id==9)"
      :key="index+20"
      :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
    >
      <img :src="getUrl(item.imageBigSrc)" />
    </router-link>

    <!--COVID Highlights-->
    <div
      class="grid-container full container"
      style="background: #f7f7f7;"
    >
      <div class="grid-x grid-padding-y grid-padding-x grid-container product-container">
        <div class="cell">
          <h2>
            {{salesHighlight}}
            <hr style="width: 56px;
                    display: inline-block;
      width: 48px;
      margin: 10px 0px 10px 20px;
      border-color: #5f5e5e;
      border-width: 1px;
                " />
          </h2>
        </div>

        <div
          class="cell large-3 medium-4 small-6"
          v-for="(item, index) in listCovid"
          :key="index+30"
          @mouseover="mouseOverIdx = index"
          @mouseleave="mouseOverIdx = -1"
        >
          <router-link
            :to="{
              name: 'product-detail',
              params: {
                productId: item.id,
                catalog: 9,
                entity: item,
              },
            }"
            class="card card-product radius"
            :class="{ shadow: mouseOverIdx === index }"
          >
            <product-card :item="item" />
          </router-link>
        </div>
      </div>
    </div>

    <!-- KITCHEN 4 PRO SECTION -->
    <!--A Presentation-->
    <router-link
      class="grid-x bg-slider home-main-slider position-relative"
      v-for="(item, index) in catalogList.filter(e=>e.id==38)"
      :key="index+40"
      :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
    >
      <img :src="getUrl(item.imageBigSrc)" />
    </router-link>

    <!--KITCHEN Highlights-->
    <div
      class="grid-container full container"
      style="background: #f7f7f7;"
    >
      <div class="grid-x grid-padding-x grid-padding-y grid-container product-container">
        <div class="cell">
          <h2>
            {{salesHighlight}}
            <hr style="width: 56px;
                    display: inline-block;
      width: 48px;
      margin: 10px 0px 10px 20px;
      border-color: #5f5e5e;
      border-width: 1px;
                " />
          </h2>
        </div>

        <div
          class="cell large-3 medium-4 small-6"
          v-for="(item, index) in listKitchen4Pro"
          :key="index+50"
          @mouseover="mouseOverIdx = index"
          @mouseleave="mouseOverIdx = -1"
        >
          <router-link
            :to="{
              name: 'product-detail',
              params: {
                productId: item.id,
                catalog: 38,
                entity: item,
              },
            }"
            class="card card-product radius"
            :class="{ shadow: mouseOverIdx === index }"
          >
            <product-card :item="item" />
          </router-link>
        </div>

      </div>
    </div>

    <!-- Banner here to help 1 -->
    <div
      class="grid-container full container"
      style="background: var(--primary-color)"
    >
      <div class="grid-container container first">
        <div class="grid-x">
          <div
            class="cell text-center"
            style="color: #fff; font-size:110%;"
          >
            <!-- <img :src="getUrl('home-contact-icon2.png')" class="radius" /> -->
            <i
              class="fi-comments"
              style="font-size: 4rem;"
            ></i>
            <br />
            <h2>
              We're here to help
            </h2>
            <h6>
              Call us on
              <a
                style="padding:0;color:inherit;display:inline;"
                href="tel:862083520905"
              >(+86) (20) 8352-0905</a>
              or email us at <a
                style="padding:0;color:inherit;display:inline;"
                href="mailto:operator@gzone1.com"
              >operator@gzone1.com</a>.
            </h6>
          </div>
        </div>
      </div>
    </div>

    <!-- LAST BANNER 2 -->
    <div
      class="grid-container full position-relative categories-section-container"
      style=""
    >
      <div
        class="grid-container full categories-section"
        style=""
      >

        <div class="grid-x medium-up-3 large-up-3 row">
          <router-link
            v-for="(item, index) in catalogList"
            :key="index+60"
            class="cell col"
            style="overflow: hidden;position:relative;"
            :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
          >
            <div
              class="photo-container"
              :style="'background-image:url(' + getUrl(item.imageSrc) + ')'"
            ></div>

            <div class="slide">
              <h3 class="text-capitalize">{{item.name}}
                <br />
                <i class="fi-play-circle"></i>
              </h3>
            </div>
          </router-link>

        </div>

      </div>
    </div>

    <!-- Introduction-->
    <div
      id="introduction"
      class="grid-container full container first"
      style="background: lightgray;"
    >
      <div class="grid-x grid-padding-x grid-container container">
        <div class="cell text-center">
          <h2
            style="font-weight: bolder;"
            class=""
          >
            One Buy
          </h2>
          <p class=" container last h5 text-justify">
            O.N.E. is a professional team with more than 15 Years of experience in the field of international business &amp; consulting between China and Middle east countries, Southern Asian Countries, European Countries .
          </p>
          <p class=" h5 text-justify">
            We have been focusing on a few selected business only such as medical equipment, Commercial Kitchen equipment, Furniture for hotels&amp;restaurants project and be professional in it.
            Not only that we have developed a vast range of products and suppliers for these fields, but also we dedicate ourselves in offering one station purchase service even in logistic service so that our clients and business partners can just order and receive their merchandise in their warehouse.
          </p>
          <p class=" h5 first text-justify padding-bottom-3">
            We have been focusing on a few selected business only such as medical equipment, Commercial Kitchen equipment, Furniture for hotels&amp;restaurants project and be professional in it.
            Not only that we have developed a vast range of products and suppliers for these fields, but also we dedicate ourselves in offering one station purchase service even in logistic service so that our clients and business partners can just order and receive their merchandise in their warehouse.
          </p>

          <router-link
            :to="{ name: 'about' }"
            class="button radius  text-uppercase large"
          >
            Learn More
          </router-link>
        </div>
      </div>
    </div>

    <!--Space-->
    <div class="container hide"></div>
  </div>
</template>

<script>
import configService from "@/app/config-service.js";
import productDataService from "@/store.product/services/main-service.js";
import catalogDataService from "@/store.catalog/services/main-service.js";

export default {
  name: "homePage",
  components: {
    "slider-carousel": () => import("@/app/components/slider-carousel"),
    "product-card": () => import("@/store.product/components/product-card"),
  },
  data () {
    return {
      salesHighlight: 'Sales highlight',

      catalogList: [],

      listTopItemsToShow: 4,

      listSaleHighLight: [],

      listHomeFitness: [],
      listCovid: [],
      listKitchen4Pro: [],
      listHomeFurniture: [],

      mouseOverIdx: -1, //related products effect
    };
  },
  computed: {
    baseUrl () {
      return configService.baseUrl;
    },
  },
  created () {
    this.initMainCatalogs();

    //TODO: Top highlights // hard-coded for now
    // this.getTopSales([32, 33, 41, 42]);
    this.getTopHomeFitness(1);
    this.getTopCovid(9);
    this.getTopKitchen(38);
    this.getTopKitchen(47);
  },
  methods: {
    getUrl (assetName) {
      return assetName ?
        require("@/assets/images/" + assetName) :
        require("@/assets/images/overlay.png");
    },
    async initMainCatalogs () {
      try {
        this.loading = true;
        const { data } = await catalogDataService.getMainCategories();
        this.setList(data);
      } catch (error) {
        this.errored = true;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    setList (items) {
      items.forEach(e => {
        switch (e.id) {
          case 1: //home
            e.imageSrc = 'home-or-left-ad.png';
            e.imageBigSrc = 'home-homefitness.jpg'
            break;
          case 9: //covid
            e.imageSrc = 'home-or-middle-ad.jpg';
            e.imageBigSrc = 'home-med1.jpg';
            break;
          case 38: //kitchen
            e.imageSrc = 'home-or-right-ad.jpg';
            e.imageBigSrc = 'home-kitch1.jpg';
            break;
          // case 47: //furniture
          //   e.imageSrc = 'home-or-right-ad.jpg';
          //   e.imageBigSrc= 'home-kitch1.jpg';
          //   break;
        }
      });


      this.catalogList = items.filter(e => e.imageSrc && e.imageSrc.length > 0);

    },
    getFnPromises (catalogId) {
      var promises = [];
      // productIds.forEach((productId) => {
      //   promises.push(productDataService.getById(productId));
      promises.push(productDataService.getTopList(catalogId, this.listTopItemsToShow));
      // });
      return promises;
    },
    getFnPromiseData (res) {
      //let data = [];
      return res.forEach((response) => {
        //data.concat(response.data);
        return response.data;
      });
      //return data;
    },
    // async getTopSales(productIds) {
    //   const res = await Promise.all(this.getFnPromises(productIds));
    //   this.listSaleHighLight = this.getFnPromiseData(res);
    // },
    async getTopHomeFitness (catalogId) {
      const { data } = await productDataService.getTopList(catalogId, this.listTopItemsToShow);
      this.listHomeFitness = data;
    },
    async getTopCovid (catalogId) {
      const { data } = await productDataService.getTopList(catalogId, this.listTopItemsToShow);
      this.listCovid = data;
    },
    async getTopKitchen (catalogId) {
      const { data } = await productDataService.getTopList(catalogId, this.listTopItemsToShow);
      this.listKitchen4Pro = data;
    },
    async getTopFurniture (catalogId) {
      const { data } = await productDataService.getTopList(catalogId, this.listTopItemsToShow);
      this.listHomeFurniture = data;
    }
  },
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

// .bg-slider {
//   background-size: cover;
//   background-position: 50% 53%;
// }
.home-main-slider {
  // .title-primary {
  //   color: rgb(255, 255, 255);
  //   //text-shadow: 0 0 20px rgba(0, 0, 0, 0.75);
  //   text-shadow: 0 0 1px rgba(0, 0, 0, 0.75);
  // }
  // .title-secondary {
  //   color: rgb(255, 255, 255);
  //   line-height: 1.3;
  //   font-weight: lighter;
  //   //text-shadow: 0 0 20px rgba(0, 0, 0, 0.75);
  //   text-shadow: 0 0 1px rgba(0, 0, 0, 0.75);
  // }
  img {
    height: 11.4375rem;

    @include breakpoint(medium) {
      height: auto;
    }
  }
}
// .overlay {
//   height: 100%;
//   width: 100%;
//   //background-color: transparent;
//   //background-color: rgba(0,0,0,.25);
//   background-color: rgba(0, 0, 0, 0.3);
//   //background: 0px 0px repeat rgba(0, 0, 0, 0.15);
//   //background: rgba(0, 0, 0, 0.05) url("~@/assets/images/overlay.png") repeat 0 0;
//   position: absolute;
//   top: 0;
//   // z-index: 1;
// }
.owl-carousel .item {
  padding: 0 !important;
}
#news {
  background: linear-gradient(to bottom, #efede8 60%, #ffffff 60%, #ffffff);
}
</style>

